// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon_iONOU {
  display: inline-block;
  transition: all .2s;
}

.accordionContent_RjiFq {
  -webkit-transition: height .2s;
  -moz-transition: height .2s;
  -ms-transition: height .2s;
  -o-transition: height .2s;
  transition: height .2s;
  overflow: hidden;
  height: 0;
}

.header_eBLqc {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/dashboard/viewer/theftRecovery/views/Accordion.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".icon {\n  display: inline-block;\n  transition: all .2s;\n}\n\n.accordionContent {\n  -webkit-transition: height .2s;\n  -moz-transition: height .2s;\n  -ms-transition: height .2s;\n  -o-transition: height .2s;\n  transition: height .2s;\n  overflow: hidden;\n  height: 0;\n}\n\n.header {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `icon_iONOU`,
	"accordionContent": `accordionContent_RjiFq`,
	"header": `header_eBLqc`
};
export default ___CSS_LOADER_EXPORT___;
